'use strict'

import apiBaseUrl from "./apiBaseUrl";

const urlBase = apiBaseUrl(window.location.origin);

export const LiveTrackingService = {
    current: (accessToken) => {
        const baseUrl = urlBase + "/livetracking";
        const url = `${baseUrl}/current`;
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': "application/json",'Accept': "application/json",
                'Authorization': accessToken
            }
        };
        return fetch(url, options)
            .then(response => {
                if(response.status == 401) {
                    // window.location = '/';
                    window.location = '/dashboard?token=1';
                }
                return response.json();
            }).catch(error => {
                return error;
            });
    }
};


// WEBPACK FOOTER //
// ./src/service/liveTrackingService.js